module.exports = __webpack_public_path__ + "media/icons/advanced-search-ec489275.png";